import React from "react";

function ImagePreview({ src, alt, previewWidth = "15cm" }) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <img
        src={src}
        alt={alt}
        style={{
          display: "block",
          width: previewWidth,
          height: "auto",
          marginTop: 10,
          borderRadius: 8,
          border: "1px solid #e5e5e5",
          boxShadow: "0 1px 6px #0001",
          cursor: "zoom-in",
          userSelect: "none",
        }}
        onClick={() => setOpen(true)}
      />
      {open && (
        <div
          onClick={() => setOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.75)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
            cursor: "zoom-out",
          }}
          role="dialog"
          aria-modal="true"
        >
          <img
            src={src}
            alt={alt}
            style={{
              maxWidth: "95vw",
              maxHeight: "95vh",
              borderRadius: 10,
              background: "#fff",
              boxShadow: "0 10px 30px rgba(0,0,0,.35)",
            }}
          />
        </div>
      )}
    </>
  );
}

export default function StatsOverviewPageIt() {
  return (
    <div
      style={{
        maxWidth: 900,
        margin: "48px auto",
        background: "#fff",
        borderRadius: 16,
        boxShadow: "0 2px 12px #0001",
        padding: 36,
        fontFamily: "inherit",
        color: "#222",
      }}
    >
        <h2 id="stats-hero" style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
        Servizi di analisi per le radio online
      </h2>

      <p style={{ margin: "16px 0 10px", fontSize: 18 }}>
        <strong>Radiomonitor.net</strong> non è solo raccolta dei dati, ma analisi approfondita.
        Vedi come cambia il pubblico in tempo reale, segui l’andamento per giorno, settimana,
        mese e persino per anno, e analizzi i prime time e l’efficacia dei contenuti.
      </p>
      <p style={{ margin: "0 0 24px", fontSize: 18 }}>
        Di seguito — i servizi che lo rendono possibile:
      </p>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Ascoltatori in tempo reale</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Cosa succede ora?</b><br />
          Mostra il numero di ascoltatori in tempo reale: adesso, da quali dispositivi e da quali città.
        </p>
        <ImagePreview src="/assets/stats/LiveService(it).png" alt="Ascoltatori live" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Ascoltatori</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Chi ti ascolta?</b><br />
          Conta tutte le connessioni e gli ascoltatori unici: la metrica base su cui si fondano tutte le altre analisi.
        </p>
        <ImagePreview src="/assets/stats/ListenersService(it).png" alt="Ascoltatori" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
          Dispositivi e OS (Devices & OS)
          <span style={{ display: 'block', fontSize: 16, fontWeight: 600, color: '#4a4a4a' }}>
            Devices & OS / Audience Devices & Operating Systems
          </span>
        </h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Questo servizio mostra da quali dispositivi e sistemi operativi gli ascoltatori accedono alla tua stazione nella data selezionata (basato sulle sessioni).
          Il sistema aggrega le sessioni di ascolto e crea un profilo chiaro dell’audience tecnica, così sai dove “vive” il tuo ascoltatore e come ottimizzare player, sito, app e creatività.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Nel report trovi:</b>
        </p>
        <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>Tipo di dispositivo (es. Mobile / Desktop / Other)</li>
          <li>Sistema operativo (Android, iOS, Windows, macOS ecc.)</li>
          <li>Famiglia di dispositivi (device family, top categorie)</li>
          <li>Client (top client: tipologie di app/player)</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>A cosa serve:</b>
        </p>
        <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>Ottimizzazione prodotto: capire cosa domina (Android vs iOS, mobile vs desktop) e dare priorità a UI/UX, test e supporto.</li>
          <li>Qualità dello stream/player: individuare rapidamente anomalie su OS o client specifici (se un certo player genera molte interruzioni o sessioni “strane”).</li>
          <li>Pianificazione dello sviluppo: decidere con dati se serve un’app dedicata/aggiornamento e quali piattaforme supportare per prime.</li>
          <li>Pubblicità e partnership: scegliere formati e creatività in base al profilo tecnico reale e dimostrarlo agli inserzionisti.</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Periodo di analisi:</b> data selezionata (eventuale filtro per paese).
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Metodologia:</b> aggregazione delle sessioni di ascolto nella data scelta → raggruppamento per tipo di dispositivo / OS / famiglia / client → conteggio di quantità e quota (%) sul totale delle sessioni.
        </p>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8 }}>
          <ImagePreview src="/assets/stats/Devices&OS01_it.png" alt="Devices & OS — panoramica" />
          <ImagePreview src="/assets/stats/Devices&OS02_it.png" alt="Devices & OS — dettagli client" />
        </div>
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Geografia del pubblico</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Dove ascoltano?</b><br />
          Individua la geografia degli ascoltatori — paesi, città, quota del pubblico ucraino. Un quadro chiaro della copertura per area.
        </p>
        <ImagePreview src="/assets/stats/Geo(it).png" alt="Geografia del pubblico" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Picchi</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Quando si ascolta di più?</b><br />
          Determina le ore di picco e il prime time: perfetto per pianificare gli spot pubblicitari.
        </p>
        <ImagePreview src="/assets/stats/PeakService(it).png" alt="Picchi" />
      </section>

      <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
            Profilo medio giornaliero di ascolto per giorno della settimana (AHA)
            <span style={{ display: 'block', fontSize: 16, fontWeight: 600, color: '#4a4a4a' }}>
              Day-of-Week Listening Profile / Average Hourly Audience by Day of Week
            </span>
          </h3>
          <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
            Questo indicatore mostra come cambia l’audience media della stazione durante la giornata in base al giorno della settimana.
            Per ciascun giorno (lunedì, martedì, … domenica) il sistema calcola il numero medio di ascoltatori per ora,
            mediando tutti i giorni omonimi nel periodo selezionato — ad esempio, tutti i lunedì di un mese o tutte le domeniche degli ultimi tre mesi.
          </p>
          <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
            <li>evidenziare le differenze tra giorni feriali e festivi;</li>
            <li>individuare le ore di maggiore attività degli ascoltatori in ogni giorno;</li>
            <li>verificare la stabilità dell’audience all’interno della settimana;</li>
            <li>confermare o correggere le fasce di prime time.</li>
          </ul>
          <p style={{ margin: "6px 0", lineHeight: 1.5 }}>
            Periodi di analisi: 1, 3, 6, 9 o 12 mesi.<br />
            Metodo di calcolo: media per minuto → media per ora → media delle stesse fasce (giorno della settimana, ora).
          </p>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, marginTop: 8 }}>
            <ImagePreview src="/assets/stats/AHA (ital)1.png" alt="Profilo medio giornaliero — grafico" />
            <ImagePreview src="/assets/stats/AHA (ital)2.png" alt="Profilo medio giornaliero — heatmap" />
          </div>
        </section>

      <section style={{ marginBottom: 18 }}>
          <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>TSL</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Per quanto tempo ascoltano?</b><br />
          Calcola il tempo medio di ascolto (TSL). Mostra il livello di engagement e la qualità dei contenuti.
        </p>
        <ImagePreview src="/assets/stats/TslService(it).png" alt="TSL" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>TLH</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          TLH (Total Listening Hours) indica quante ore complessive la tua stazione è stata ascoltata nel periodo selezionato.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Cosa misura il TLH?</b><br />
          Somma la durata di tutte le sessioni di ascolto e la converte in ore:
        </p>
        <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>TLH per giorno — quante «ore persona» di ascolto ci sono state in una data.</li>
          <li>TLH per periodo (totale) — il numero di ore di ascolto accumulate sull’intervallo (giorno/settimana/mese).</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          In parole semplici, TLH risponde alla domanda: «Quanto tempo il pubblico ha passato con la nostra stazione?».
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Perché è utile</b><br />
          TLH è una delle «monete» più chiare per valutare il pubblico e monetizzarlo:
        </p>
        <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>Vendita pubblicità: TLH si spiega facilmente agli inserzionisti come volume di contatto con il contenuto — «tante ore persona di ascolto».</li>
          <li>Confronto dei periodi: mostra subito se il volume totale di ascolto cresce di settimana in settimana o mese su mese.</li>
          <li>Valutare cambiamenti e promo: dopo campagne, modifiche di format o conduttori il TLH indica se il «tempo di attenzione» complessivo è aumentato.</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Come interpretare il TLH</b>
        </p>
        <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>Grafico giornaliero — quante ore di ascolto ha generato ogni giorno.</li>
          <li>TLH (totale) — la somma delle ore per l’intero periodo.</li>
          <li>Numero di sessioni — quante connessioni ci sono state (aiuta a capire cosa fa crescere o diminuire il TLH).</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          TLH funziona bene insieme a metriche come il TSL, ma da solo offre già un numero molto comprensibile in ottica commerciale: le ore di attenzione ricevute.
        </p>
        <ImagePreview src="/assets/stats/tlh_it.png" alt="TLH" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Nuovi ascoltatori</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Quanti nuovi arrivano?</b><br />
          Determina il numero di nuovi ascoltatori per giorno, settimana o mese per capire come cresce il pubblico.
        </p>
        <ImagePreview src="/assets/stats/NewListenersService(it).png" alt="Nuovi ascoltatori" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>ADR (Average Daily Reach)</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Copertura media giornaliera della stazione.</b>
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Questa metrica mostra quanti <b>ascoltatori unici</b> arrivano in media ogni giorno nel periodo selezionato.
          Per ciascun giorno il sistema conta le persone diverse che hanno ascoltato la radio e poi calcola la media sull’intero intervallo.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>ADR ti permette di:</p>
        <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>valutare la <b>dimensione reale del pubblico quotidiano</b> della stazione;</li>
          <li>capire quanto stabilmente la radio attira ascoltatori nel periodo scelto;</li>
          <li>sostenere le proposte commerciali con un <b>numero chiaro di copertura</b> per l’intervallo.</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Periodo di analisi:</b> l’intervallo di date selezionato all’interno dello storico disponibile.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}><b>Metodo di calcolo:</b></p>
        <ol style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>Per ciascun giorno del periodo si determina il <b>numero di ascoltatori unici in 24 ore</b>.</li>
          <li>I valori giornalieri vengono poi <b>mediati</b>, formando l’Average Daily Reach per l’intero intervallo.</li>
        </ol>
        <ImagePreview src="/assets/stats/ADR (it).png" alt="ADR — esempio" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>AQH (Average Quarter-Hour Audience)</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Numero medio di ascoltatori simultanei.</b>
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Mostra <b>quanti ascoltatori contemporaneamente</b> seguono la stazione in media nel periodo selezionato.
          Le sessioni vengono aggregate in intervalli temporali (per esempio orari) e per ogni intervallo viene mostrata l’audience media.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>AQH consente di:</p>
        <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>vedere come cambia l’audience durante la giornata;</li>
          <li>individuare le ore con più e meno ascoltatori;</li>
          <li>pianificare gli spot pubblicitari nei momenti più convenienti;</li>
          <li>valutare l’effetto delle modifiche nel palinsesto sul pubblico reale.</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Periodo di analisi:</b> qualsiasi intervallo di date disponibile.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}><b>Metodo di calcolo:</b></p>
        <ol style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>Per ogni minuto si registra il numero di sessioni attive.</li>
          <li>Per ogni intervallo temporale (es. ora) si calcola la <b>media dei valori minuto per minuto</b>.</li>
          <li>I valori degli intervalli formano il profilo AQH del periodo scelto.</li>
        </ol>
        <ImagePreview src="/assets/stats/AQH (it)01.png" alt="AQH — grafico" />
        <ImagePreview src="/assets/stats/AQH (it)02.png" alt="AQH — heatmap" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
          Reach (Period Reach)
        </h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Reach mostra <b>quanti ascoltatori unici</b> hanno ascoltato almeno una volta la stazione nel periodo selezionato.
          Tutti i ritorni dello stesso ascoltatore unico — nello stesso giorno, settimana o mese — vengono contati una sola volta.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>Reach permette di:</p>
        <ul style={{ margin: "6px 0 6px 22px", lineHeight: 1.5 }}>
          <li>vedere quanti ascoltatori unici hanno acceso la stazione almeno una volta in un giorno, settimana, mese o intervallo personalizzato;</li>
          <li>mostrare agli inserzionisti quante persone diverse hanno davvero potuto sentire i loro annunci in quel periodo;</li>
          <li>consultare la geografia di questi ascoltatori unici (top paesi + quota “senza geografia”).</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55, fontWeight: 600 }}>Come viene calcolato:</p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Per il periodo scelto raccogliamo tutti coloro che hanno ascoltato almeno una volta e contiamo ogni ascoltatore una sola volta.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Se un ascoltatore ha ascoltato la radio 10 volte in una settimana, in Reach vale comunque come 1 ascoltatore settimanale, non 10.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Esempio: una persona ascolta lunedì, mercoledì e venerdì — nel Reach settimanale viene conteggiata come un solo ascoltatore per la settimana.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Perciò Reach non mostra il numero di accensioni, ma quante persone diverse hanno ascoltato la radio almeno una volta nel periodo.
        </p>
        <ImagePreview src="/assets/stats/Reach_it.png" alt="Reach — esempio" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Retention</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Gli ascoltatori tornano?</b><br />
          Misura quanti nuovi ascoltatori ritornano il giorno dopo o entro una settimana — chiave per valutare la prima esperienza.
        </p>
        <ImagePreview src="/assets/stats/RetentionService(it).png" alt="Retention" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Indice di fedeltà</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Chi è il tuo nucleo?</b><br />
          Evidenzia gli ascoltatori abituali e fedeli. Mostra la forza del brand e la fiducia nei contenuti.
        </p>
        <ImagePreview src="/assets/stats/LoyaltyService(it).png" alt="Indice di fedeltà" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>TOP</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Cosa è più popolare?</b><br />
          Crea classifiche: città, piattaforme, dispositivi e — se disponibili — musica e programmi.
          Statistiche pronte per le presentazioni.
          <br />
          Richiede l’importazione del palinsesto della stazione.
        </p>
        <ImagePreview src="/assets/stats/Top40Service(it).png" alt="TOP" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>LTR (Listen-Through Rate)</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Ascolto completo degli spot audio.</b><br />
          LTR mostra quale percentuale di ascoltatori resta fino alla fine di ogni blocco pubblicitario. Trasforma il dato 'lo spot è andato
          in onda' nella domanda più onesta: <b>'Quante persone hanno davvero ascoltato la pubblicità fino alla fine?'</b>
        </p>
        <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Cosa misura LTR</h4>
        <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
          <li><b>Impressions</b> — quanti ascoltatori unici sono collegati all'inizio del blocco;</li>
          <li><b>Completions</b> — quanti restano fino alla fine;</li>
          <li><b>LTR, %</b> — la quota che ascolta tutto (Completions/Impressions × 100).</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          I dati vengono mostrati per ogni blocco del giorno selezionato: orari di inizio/fine, composizione (spot), numero di ascoltatori e
          percentuale di completamento.
        </p>
        <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Come funziona</h4>
        <ol style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
          <li>Il servizio prende il palinsesto reale e identifica automaticamente i blocchi pubblicitari.</li>
          <li>Per ogni blocco registra chi ascoltava all'avvio (impressions) e chi è arrivato alla fine (completions) in base alle sessioni.</li>
          <li>Su questa base il sistema calcola LTR in percentuale per ogni blocco.</li>
        </ol>
        <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Perché usarlo</h4>
        <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
          <li>Valutare l'efficacia degli spot audio e individuare eventuali cali di ascolto.</li>
          <li>Confrontare creatività e pianificazioni per capacità di trattenere il pubblico.</li>
          <li>Ottimizzare il palinsesto e capire quali fasce orarie funzionano meglio.</li>
          <li>Portare argomentazioni commerciali con una percentuale reale di ascolto completo.</li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          LTR è disponibile nella sezione «Statistiche» come strumento dedicato per l'analisi dei blocchi pubblicitari.
        </p>
        <ImagePreview src="/assets/stats/lpt_it.png" alt="LTR — esempio interfaccia" />
      </section>

      <section style={{ marginBottom: 18 }}>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>
          Quartiles LTR (Listen-Through Rate by Quartiles)
        </h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Ascolto dell’audio adv per quartili.</b>
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Il servizio Quartiles LTR mostra quanti ascoltatori reali hanno seguito uno spot fino al 25%, 50%, 75% e 100% della durata.
          Per ogni uscita vengono registrate le Impressions (quanti ascoltatori unici erano collegati all’inizio) e quante persone hanno raggiunto ciascun quartile.
        </p>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Se LTR restituisce un solo dato finale (“ha ascoltato/non ha ascoltato”), Quartiles LTR indica il punto preciso in cui l’audience inizia a calare.
        </p>
        <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Cosa misura Quartiles LTR</h4>
        <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
          <li>
            <b>Impressions</b> — quanti ascoltatori unici sono collegati allo start dello spot.
          </li>
          <li>
            <b>Q25/Q50/Q75/Q100</b> — quanti arrivano al 25%, 50%, 75% e 100% della durata.
          </li>
          <li>
            Per ogni uscita viene generata una riga giornaliera: orario di inizio/fine, nome del creativo, audience su ciascun quartile.
          </li>
        </ul>
        <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Analisi aggiuntive</h4>
        <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
          <li>
            <b>GEO per spot</b> — quanti ascoltatori di quella messa in onda arrivano da ogni paese.
          </li>
          <li>
            <b>Livello IP</b> — elenco tecnico degli indirizzi IP per uno spot e una nazione specifica.
          </li>
        </ul>
        <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Come funziona</h4>
        <ol style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
          <li>Il servizio importa il palinsesto reale e individua tutte le uscite pubblicitarie della giornata.</li>
          <li>Per ciascuna uscita identifica tutti gli ascoltatori presenti allo start (impressions).</li>
          <li>I dati di sessione mostrano quanta parte dello spot è stata realmente ascoltata da ogni ascoltatore (tolleranza ±5 secondi).</li>
          <li>Ogni ascoltatore viene assegnato al quartile massimo raggiunto (0/25/50/75/100%), quindi si calcola l’audience per livello.</li>
          <li>In parallelo vengono generati lo slice GEO per spot (paese → ascoltatori) e la lista IP.</li>
        </ol>
        <h4 style={{ margin: "12px 0 6px", fontSize: 18, fontWeight: 700 }}>Perché usarlo</h4>
        <ul style={{ margin: "0 0 12px 22px", lineHeight: 1.55 }}>
          <li>Valutare l’efficacia reale dell’audio adv oltre al semplice “lo spot è andato in onda”.</li>
          <li>Confrontare creatività e placement in base alla profondità di ascolto.</li>
          <li>Capire come incide la posizione dello spot nel blocco (primo, centrale, ultimo).</li>
          <li>Analizzare il GEO: come reagiscono i paesi e se la campagna raggiunge i mercati necessari.</li>
          <li>Svolgere audit tecnici dettagliati grazie al livello IP quando serve.</li>
          <li>
            Attivare modelli “pay-per-listen”: conteggiare solo chi ha ascoltato almeno il 50–75% all’interno del paese richiesto.
          </li>
        </ul>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          Quartiles LTR è disponibile nella sezione Statistiche come strumento dedicato per analizzare gli spot con dettaglio per quartili, GEO e IP.
        </p>
        <ImagePreview src="/assets/stats/quartiles_ltr_it01.png" alt="Quartiles LTR — tabella quartili" />
        <ImagePreview src="/assets/stats/quartiles_ltr_it02.png" alt="Quartiles LTR — dettaglio GEO" />
        <ImagePreview src="/assets/stats/quartiles_ltr_it03.png" alt="Quartiles LTR — elenco IP" />
      </section>

      <section>
        <h3 style={{ fontWeight: 800, fontSize: 22, margin: "12px 0 6px" }}>Statistiche pubblicitarie</h3>
        <p style={{ margin: "6px 0", lineHeight: 1.55 }}>
          <b>Quanto sono efficaci gli annunci?</b><br />
          Calcola impression, copertura, frequenza e CPM — statistiche chiare e trasparenti per gli inserzionisti.
          <br />
          Richiede l’importazione del palinsesto della stazione.
        </p>
        <ImagePreview src="/assets/stats/AdsService(it).png" alt="Statistiche pubblicitarie" />
      </section>
    </div>
  );
}
